export const BILLINGPOC = "BILLING ADDRESS";

